var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      class: ["parametric-row", { "is-booked": _vm.flat.isBooked }],
      on: {
        click: function($event) {
          return _vm.redirectLeft(_vm.flat.link)
        },
        contextmenu: function($event) {
          return _vm.redirectRight(_vm.flat.link)
        }
      }
    },
    [
      _c("td", [
        _c(
          "div",
          {
            class: [
              "parametric-row__plan",
              { "parametric-row__plan_theme_up": _vm.isBottom }
            ],
            on: {
              mouseenter: _vm.setPreviewPosition,
              mouseleave: function($event) {
                _vm.isBottom = false
              }
            }
          },
          [
            _c("div", { staticClass: "parametric-results__loader" }, [
              _c("img", {
                staticClass: "parametric-row__plan-img",
                attrs: { src: _vm.flat.plan, alt: _vm.flat.title }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "parametric-row__plan-big" }, [
              _c("img", {
                attrs: { src: _vm.flat.planBig, alt: _vm.flat.title }
              })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "parametric-row__title-cell" }, [
        _c("div", { staticClass: "parametric-row__title" }, [
          _c("div", { staticClass: "parametric-results__loader" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.flat.title) +
                "\n                "
            ),
            !_vm.isEstateFlat && _vm.flat.building && _vm.flat.section
              ? _c("div", { staticClass: "parametric-results__annotation" }, [
                  _vm._v(
                    "\n                    Корпус " +
                      _vm._s(_vm.flat.building) +
                      ", секция " +
                      _vm._s(_vm.flat.section) +
                      "\n                "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.flat.options
          ? _c(
              "ul",
              { staticClass: "tags tags_theme_not-order" },
              _vm._l(_vm.flat.options, function(option) {
                return _c(
                  "li",
                  {
                    key: option.key,
                    class: [
                      "tags__item",
                      "tags__item_color_" + option.id,
                      "tags__item_theme_flat",
                      "tags__item_theme_narrow",
                      "parametric-results__loader"
                    ]
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(option.name) +
                        "\n            "
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("td", [
        _c("div", { staticClass: "parametric-results__loader" }, [
          _vm._v(_vm._s(_vm.flat.area))
        ])
      ]),
      _vm._v(" "),
      _vm.isEstateFlat
        ? _c("td", [
            _c("div", { staticClass: "parametric-results__loader" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.flat.floor) + "\n            "
              ),
              _c("span", { staticClass: "parametric-row__floors" }, [
                _vm._v("из " + _vm._s(_vm.flat.floorsTotal))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("td", [
        _c("div", { staticClass: "parametric-results__loader" }, [
          _vm._v(_vm._s(_vm.flat.deadlineText))
        ])
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "parametric-row__price-cell" }, [
        !_vm.flat.isBooked
          ? _c("ul", { staticClass: "parametric-row__prices-list" }, [
              _c(
                "li",
                {
                  staticClass:
                    "parametric-row__prices-item parametric-results__loader"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.convertToDigit(_vm.flat.price)) +
                      "\n\n                "
                  ),
                  _vm.flat.action
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "parametric-row__price-action action-label"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.flat.action.value) +
                              "\n                    "
                          ),
                          _c("div", { staticClass: "action-label__tooltip" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.flat.action.text) +
                                "\n                    "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.flat.priceOld
                ? _c(
                    "li",
                    {
                      staticClass:
                        "parametric-row__prices-item parametric-row__price-old\n                parametric-results__loader"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.convertToDigit(_vm.flat.priceOld)) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.flat.isBooked
          ? _c(
              "div",
              {
                staticClass:
                  "parametric-row__reserved-text parametric-results__loader"
              },
              [_vm._v("\n            Забронировано\n        ")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }